import Typography from '@/components/UI/typography/Typography'
import styles from './GetPhoneNumber.module.scss'
import Box from '@/components/UI/box/Box'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { useOpenLoginModal } from '@/hooks/useOpenLoginModal'
import Alert from '@/components/UI/alert/Alert'
import PhoneNumberForm from './phoneNumberForm/PhoneNumberForm'
import { useIsWhiteLabel } from '@/components/app/providers/whiteLabelProvider/WhiteLabelProvider'

const GetPhoneNumber = () => {
  const { loginDrawerState } = useOpenLoginModal()
  const router = useRouter()
  const isWhiteLabel = useIsWhiteLabel()
  const hasNextUrl = router.query.next_url

  return (
    <Box
      className={`${styles['get-phone-number']} ${styles['slide-in-right']}`}
    >
      {(loginDrawerState.message || hasNextUrl) && (
        <Alert
          title={
            hasNextUrl
              ? 'برای مشاهده این صفحه لطفا ابتدا وارد حساب کاربری شوید.'
              : (loginDrawerState.message as string)
          }
          type="secondary"
          icon="info-circle"
          className={styles['alert']}
        />
      )}
      <Typography className={styles['info-text']} variant="bodyM" component="p">
        لطفا شماره همراه خود را وارد کنید:
      </Typography>
      <PhoneNumberForm />
      {!isWhiteLabel && (
        <Typography variant="bodyS" component="p">
          ورود یا ثبت‌نام به معنای پذیرش
          <Link
            href="/policies"
            target="_blank"
            rel="noopener noreferrer"
            passHref
          >
            <Typography variant="bodyS" color="primary_main">
              {' '}
              قوانین سایت شب{' '}
            </Typography>
          </Link>
          است.
        </Typography>
      )}
    </Box>
  )
}

export default GetPhoneNumber
